import { Skeleton } from '@aimsos/ui';

/** One card-shaped placeholder: avatar tile + name/badges + a chip row. */
function CardSkeleton({ hero = false }) {
  return (
    <div
      className={[
        'rounded-2xl border border-edge bg-surface/40',
        hero ? 'p-6' : 'p-4',
      ].join(' ')}
    >
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center">
        <div className="flex min-w-0 items-start gap-3 lg:w-72 lg:flex-shrink-0">
          <Skeleton
            width={hero ? 48 : 40}
            height={hero ? 48 : 40}
            borderRadius={12}
            className="flex-shrink-0"
          />
          <div className="min-w-0 flex-1 space-y-2">
            <Skeleton width={hero ? '70%' : '55%'} height={hero ? 16 : 14} />
            <div className="flex gap-1.5">
              <Skeleton width={72} height={20} borderRadius={999} />
              <Skeleton width={64} height={20} borderRadius={999} />
            </div>
          </div>
        </div>

        <div className="min-w-0 flex-1 space-y-2">
          <Skeleton width={90} height={11} />
          <div className="flex flex-wrap gap-2">
            <Skeleton width={104} height={28} borderRadius={8} />
            <Skeleton width={128} height={28} borderRadius={8} />
            <Skeleton width={96} height={28} borderRadius={8} />
          </div>
        </div>

        <div className="lg:w-44 lg:flex-shrink-0">
          <Skeleton width="100%" height={12} />
        </div>
      </div>
    </div>
  );
}

/**
 * Loading state for the selector, shaped like the real content — one hero card
 * plus a few compact rows under an "other workspaces" heading — instead of a
 * bare centered spinner, so the layout doesn't jump when the data lands.
 */
function WorkspaceListSkeleton({ rows = 4 }) {
  return (
    <div className="flex flex-col gap-3" aria-busy="true" aria-live="polite">
      <CardSkeleton hero />
      <Skeleton width={130} height={11} className="mt-4" />
      {Array.from({ length: rows }, (_, i) => (
        <CardSkeleton key={i} />
      ))}
    </div>
  );
}

export default WorkspaceListSkeleton;
